export default __webpack_public_path__ + "static/media/closed.3e13cd62.png";